export default __webpack_public_path__ + "static/media/logo.3c09dcb5.png";